import { __decorate, __extends } from "tslib";
import { Component } from 'vue-property-decorator';
import AbpBase from '../lib/AbpBase';
var LanguageSwitch = /** @class */ (function (_super) {
    __extends(LanguageSwitch, _super);
    function LanguageSwitch() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(LanguageSwitch.prototype, "languages", {
        get: function () {
            return abp.localization.languages.filter(function (val) {
                return !val.isDisabled;
            });
        },
        enumerable: true,
        configurable: true
    });
    LanguageSwitch.prototype.changeLanguage = function (languageName) {
        abp.utils.setCookieValue("Abp.Localization.CultureName", languageName, new Date(new Date().getTime() + 5 * 365 * 86400000), //5 year
        abp.appPath);
        location.reload();
    };
    Object.defineProperty(LanguageSwitch.prototype, "currentLanguage", {
        get: function () {
            return abp.localization.currentLanguage;
        },
        enumerable: true,
        configurable: true
    });
    LanguageSwitch = __decorate([
        Component
    ], LanguageSwitch);
    return LanguageSwitch;
}(AbpBase));
export default LanguageSwitch;
